module.exports = __webpack_public_path__ + "img/11展会.81c1a8be.jpg";